import { useState } from "react";
import { api } from "../api";
import { PageDialog } from "./ReferenceUI";

const reasons = [
  ["suspected_minor", "Младше 18"],
  ["fraud", "Мошенник"],
  ["unwanted_sexual_content", "Непристойное поведение"],
  ["spam", "Реклама услуг"],
  ["fake_profile", "Фейк"],
  ["abuse_or_threats", "Оскорбления и угрозы"],
  ["other", "Другое"],
] as const;
export function ReportDialog({ userId, onClose }: { userId: string; onClose(): void }) {
  const [reason, setReason] = useState<string | null>(null);
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const send = async () => {
    if (!reason || busy) return;
    setBusy(true);
    setError("");
    try {
      await api(`/v1/users/${userId}/report`, {
        method: "POST",
        body: JSON.stringify({ reason, ...(details.trim() ? { details: details.trim() } : {}) }),
      });
      setSent(true);
    } catch {
      setError("Не удалось отправить жалобу. Попробуйте ещё раз.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <PageDialog title="Пожаловаться" onClose={onClose} busy={busy}>
      {sent ? (
        <>
          <h2>Жалоба отправлена</h2>
          <p>Модератор проверит обращение.</p>
          <button type="button" className="reference-primary" onClick={onClose}>
            Закрыть
          </button>
        </>
      ) : (
        <>
          <div className="reference-group">
            {reasons.map(([value, label]) => (
              <label className="reference-row" key={value}>
                <span className="reference-row-label">{label}</span>
                <input type="radio" name="report-reason" checked={reason === value} onChange={() => setReason(value)} />
              </label>
            ))}
          </div>
          <textarea
            className="reference-input"
            aria-label="Подробности жалобы"
            placeholder="Расскажите подробнее"
            maxLength={1000}
            rows={5}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
          <small className="reference-counter">{details.length}/1000</small>
          {error && (
            <p role="alert" className="reference-error">
              {error}
            </p>
          )}
          <button
            type="button"
            className="reference-primary reference-save"
            disabled={!reason || busy}
            onClick={() => void send()}
          >
            {busy ? "Отправляем…" : "Отправить"}
          </button>
        </>
      )}
    </PageDialog>
  );
}
